import React, { useEffect, useRef, useState } from 'react';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link, useParams } from 'react-router-dom';

import SelectionFilter, { isValidIds } from '../../components/Filter/SelectionFilter';
// import Pagination from '../../components/Pagination/PerformerPagination';
import AscendingSvg from '../../components/Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../components/Form/SortSvg/DescendingSvg';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../redux/actions/user/getUsers';
import { useForm } from 'react-hook-form';
import PerformerList from '../../components/List/Performer/PerformerList';
import { Modal, Pagination } from 'antd';
import ProfileIndex from '../Profile/ProfileIndex';
import { updateModerationVacancy } from '../../redux/actions/dashborad/updateModerationVacancy';
import { sendCandidateList } from '../../redux/actions/broadcast/sendCandidateList';
import Loading from '../../components/Loading/Loading';
import { resetClearCandidateList, resetSendCandidateList } from '../../redux/slices/broadcast.slice';
import { toast } from 'react-toastify';
import { getCandidateList } from '../../redux/actions/broadcast/getCandidateList';
import { clearCandidateList } from '../../redux/actions/broadcast/clearCandidateList';
import { getEmployerStats } from '../../redux/actions/employer/getEmployerStats';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Swal from 'sweetalert2';
import { deleteListEmployer } from '../../redux/actions/employer/deleteListEmployer';
import { resetDeleteListEmployer } from '../../redux/slices/employer.slice';
import { getUserStats } from '../../redux/actions/user/getUserStats';
import { deleteUserList } from '../../redux/actions/user/deleteUserList';
import { resetBlockUserList, resetDeleteUserList } from '../../redux/slices/user.slice';
import { blockUserList } from '../../redux/actions/user/blockUserList';
import NotificationModal from '../../components/Modal/NotificationModal';
import { getMailingUsers } from '../../redux/actions/chat/getMailingUsers';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function SelectionPerformer({ isSelectApplicant, onSendApplicant, title, isApplicants, onClose, isMailing, mailingId, sliceName = 'user', actionName = 'getUsers', mailingMessage }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [notification, setNotification] = useState(false);
  const [selectApplicant, setSelectApplicant] = useState();
  const { id } = useParams();
  const formFilter = useForm({
    defaultValues: {
      sex: 'null',
      number: '',
      full_name: '',
      age_from: '',
      age_to: '',
      has_avatar: false,
      created_at_to: null,
      created_at_from: null,
    },
  });
  const formChecked = useForm({
    defaultValues: {
      userChecked: {},
    },
  });

  const formFilterData = formFilter.watch();
  const userChecked = formChecked.watch('userChecked');

  const handleDelete = () => {
    Swal.fire({
      title: 'Вы действительно хотите удалить выбранных соискателей?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteUserList({
            users: Object.keys(userChecked)
              ?.filter((key) => userChecked[key])
              .map((key) => key),
            is_active: false,
          }),
        );
      }
    });
  };

  const handleRestore = () => {
    Swal.fire({
      title: 'Вы действительно хотите восстановить выбранных соискателей?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteUserList({
            users: Object.keys(userChecked)
              ?.filter((key) => userChecked[key])
              .map((key) => key),
            is_active: true,
          }),
        );
      }
    });
  };

  const handleBlock = () => {
    Swal.fire({
      title: 'Вы действительно хотите заблокировать выбранных соискателей?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockUserList({
            users: Object.keys(userChecked)
              ?.filter((key) => userChecked[key])
              .map((key) => key),
            is_blocked: true,
          }),
        );
      }
    });
  };
  const handleUnblock = () => {
    Swal.fire({
      title: 'Вы действительно хотите разблокировать выбранных соискателей?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockUserList({
            users: Object.keys(userChecked)
              ?.filter((key) => userChecked[key])
              .map((key) => key),
            is_blocked: false,
          }),
        );
      }
    });
  };
  const dispatch = useDispatch();
  const {
    // getUsers: { data: getUsersData, error: getUsersError, loading: getUsersLoading },
    getUserStats: { data: getUserStatsData, error: getUserStatsError, loading: getUserStatsLoading },
    deleteUserList: { data: deleteUserListData, error: deleteUserListError, loading: deleteUserListLoading },
    blockUserList: { data: blockUserListData, error: blockUserListError, loading: blockUserListLoading },
  } = useSelector((state) => state.user);
  const selector = useSelector((state) => state[sliceName]);
  const selectorData = selector[actionName];
  // const { } = useSelector(state => state.)

  const {
    getCandidateList: { data: getCandidateListData, error: getCandidateListError, loading: getCandidateListLoading },
    sendCandidateList: { data: sendCandidateListData, error: sendCandidateListError, loading: sendCandidateListLoading },
    clearCandidateList: { data: clearCandidateListData, error: clearCandidateListError, loading: clearCandidateListLoading },
  } = useSelector((state) => state.broadcast);

  useEffect(() => {
    if (deleteUserListData) {
      Swal.fire({
        title: activeTab == 'deleted' ? 'Соискатели восстановлены' : 'Соискатели перемещены в удаленые',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      formChecked.setValue('userChecked', {});
      dispatch(getUserStats({ type: 'candidate' }));
      onFetch(formFilterData);

      dispatch(resetDeleteUserList());
    }
  }, [deleteUserListData]);

  useEffect(() => {
    if (blockUserListData) {
      Swal.fire({
        title: activeTab == 'blocked' ? 'Соискатели разблокированы' : 'Соискатели перемещены в заблокированные',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      formChecked.setValue('userChecked', {});
      dispatch(getUserStats({ type: 'candidate' }));
      onFetch(formFilterData);

      dispatch(resetBlockUserList());
    }
  }, [blockUserListData]);

  useEffect(() => {
    if (sendCandidateListData) {
      toast.success('Выбранные исполнители сохранены', { theme: 'colored', autoClose: '3000' });
      dispatch(getCandidateList(id));
      dispatch(resetSendCandidateList());
      onClose();
    }
  }, [sendCandidateListData]);

  useEffect(() => {
    if (clearCandidateListData) {
      toast.success('Выбранные исполнители очищены', { theme: 'colored', autoClose: '3000' });
      dispatch(getCandidateList(id));
      dispatch(resetClearCandidateList());
      onClose();
    }
  }, [clearCandidateListData]);
  const handleNotification = () => {
    setNotification(true);
  };
  useEffect(() => {
    if (getCandidateListData) {
      let candidateChecked = {};
      getCandidateListData?.candidates?.map((cand) => {
        candidateChecked = { ...candidateChecked, [cand.id]: true };
      });
      formChecked.setValue('userChecked', candidateChecked);
    }
  }, [getCandidateListData]);

  const [openUser, setOpenUser] = useState(null);
  useEffect(() => {
    if (isMailing) {
      dispatch(getMailingUsers({ page: currentPage, ...getFormatFilter(formFilterData), mailingId }));
    } else {
      dispatch(getUsers({ page: currentPage, ...getFormatFilter(formFilterData), ...tabs[activeTab]?.params }));
    }
  }, [currentPage]);

  const getFormatFilter = (data) => {
    let filter = {};
    if (data.age_from && parseInt(data.age_from)) {
      filter = { ...filter, age_from: parseInt(data.age_from) };
    }
    if (data.age_to && parseInt(data.age_to)) {
      filter = { ...filter, age_to: parseInt(data.age_to) };
    }
    if (data.has_avatar) {
      filter = { ...filter, has_avatar: true };
    }
    if (data.full_name) {
      filter = { ...filter, full_name: data.full_name };
    }
    if (data.sex == 'true' || data.sex == 'false') {
      filter = { ...filter, sex: data.sex == 'true' ? true : false };
    }
    if (data.number) {
      const filterNumber = data.number.includes('-')
        ? {
            id_from: parseInt(data.number.split('-')[0]),
            id_to: parseInt(data.number.split('-')[1]),
          }
        : data.number.includes(',')
        ? {
            ids: data.number,
          }
        : { ids: parseInt(data.number) };
      filter = { ...filter, ...filterNumber };
    }
    if (data.created_at_to) {
      filter = { ...filter, created_at_to: data.created_at_to };
    }
    if (data.created_at_from) {
      filter = { ...filter, created_at_from: data.created_at_from };
    }
    return filter;
  };
  const onFetch = (value, tab) => {
    if (currentPage == 1) {
      if (isMailing) {
        dispatch(getMailingUsers({ page: currentPage, ...getFormatFilter(value), mailingId }));
      } else {
        dispatch(getUsers({ page: currentPage, ...getFormatFilter(value), ...tabs[tab ? tab : activeTab]?.params }));
      }
    } else {
      setCurrentPage(1);
    }
  };
  const errorNumber = formFilter?.formState?.errors?.number;
  React.useEffect(() => {
    const subscription = formFilter.watch((value, { name, type }) => {
      if (name !== 'userCheked' && isValidIds(value?.number)) {
        onFetch(value);
      }
    });
    return () => subscription.unsubscribe();
  }, [formFilter.watch, currentPage, errorNumber]);

  useEffect(() => {
    if (isApplicants) {
      dispatch(getUserStats({ type: 'candidate' }));
    }
  }, []);

  const tabs = {
    total: {
      label: 'Все',
      params: {
        is_active: true,
        is_blocked: false,
      },
    },
    deleted: {
      label: 'Удаленные',
      params: {
        is_active: false,
        is_blocked: false,
      },
    },
    blocked: {
      label: 'Заблокированные',
      params: {
        is_active: false,
        is_blocked: true,
      },
    },
  };
  const [activeTab, setActiveTab] = useState('total');
  const onSubmit = (data) => {
    dispatch(sendCandidateList({ vacancyId: id, data: { items: Object.keys(data.userChecked)?.map((key) => parseInt(key)) } }));
  };

  return (
    <div className="mx-auto flex flex-1 flex-col w-full max-w-[1163px] h-full">
      {sendCandidateListLoading && (
        <div className="fixed t-0 l-0 r-0 b-0 z-50 w-[100vw] h-[100vh]">
          <div className="fixed  w-[32px] h-[32px] right-4 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-white">
            <Loading />
          </div>
        </div>
      )}
      <div className="w-full  p-2 pt-0 pr-10">
        <div className="flex flex-col 468:flex-row justify-between gap-3">
          <p className="text-2xl font-medium">{title ? title : isApplicants ? 'Соискатели' : 'Выборка исполнителей'}</p>
          <p className="flex flex-wrap justify-center items-center">
            {!isApplicants && (
              <button
                type="button"
                onClick={() => {
                  dispatch(clearCandidateList(id));
                  formChecked.setValue('userChecked', {});
                }}
                className="text-center border rounded py-2 px-2  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                Очистить выбор
              </button>
            )}
          </p>
        </div>
      </div>{' '}
      {mailingMessage && <div className="pl-2 text-gray-400">{mailingMessage}</div>}
      <div className="w-full flex flex-col first:flex-row p-2 mt-2 gap-x-3 justify-between">
        <div className="w-full first:w-3/4 flex flex-col">
          {!isMailing && (
            <>
              {!isApplicants ? (
                <div className="w-full flex flex-col 468:flex-row justify-between 468:items-center gap-3">
                  <p className="px-2">Выбрано: {Object.keys(userChecked)?.length}</p>
                </div>
              ) : (
                <>
                  <div className="flex justify-between lg:justify-start gap-3">
                    {' '}
                    <ul className="hidden md:flex list-none gap-3 py-2 ">
                      {Object.keys(tabs).map((key) => (
                        <li
                          className={`cursor-pointer ${activeTab === key ? 'font-bold underline' : ''}`}
                          onClick={() => {
                            setActiveTab(key);
                            onFetch(formFilterData, key);
                          }}>
                          {tabs[key].label} ({getUserStatsData?.[key]})
                        </li>
                      ))}
                    </ul>
                    {Object.keys(userChecked).length ? (
                      <Menu as="div" className="relative inline-block text-left">
                        <div>
                          <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                            Действия
                            <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                          </Menu.Button>
                        </div>

                        <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {activeTab == 'total' ? (
                              <div className="py-1">
                                <Menu.Item>
                                  {({ active }) => (
                                    <Link onClick={handleDelete} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                      Удалить
                                    </Link>
                                  )}
                                </Menu.Item>
                              </div>
                            ) : activeTab === 'deleted' ? (
                              <div className="py-1">
                                <Menu.Item>
                                  {({ active }) => (
                                    <Link onClick={handleRestore} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                      Восстановить
                                    </Link>
                                  )}
                                </Menu.Item>{' '}
                                <Menu.Item>
                                  {({ active }) => (
                                    <Link onClick={handleBlock} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                      Заблокировать
                                    </Link>
                                  )}
                                </Menu.Item>
                              </div>
                            ) : activeTab === 'blocked' ? (
                              <>
                                {' '}
                                <div className="py-1">
                                  <Menu.Item>
                                    {({ active }) => (
                                      <Link onClick={handleUnblock} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                        Разблокировать
                                      </Link>
                                    )}
                                  </Menu.Item>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {isApplicants && (
                              <Menu.Item>
                                {({ active }) => (
                                  <Link onClick={handleNotification} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                    Уведомить
                                  </Link>
                                )}
                              </Menu.Item>
                            )}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="flex md:hidden">
                    <Menu as="div" className="relative inline-block text-left">
                      <div>
                        <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                          {tabs[activeTab]?.label}
                          {/* {active === 'all' ? 'Все: 150' : active === 'deleted' ? 'Удаленные: 50' : 'Заблокированные: 100'} */}
                          <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                        </Menu.Button>
                      </div>

                      <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                        <Menu.Items className="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="py-1">
                            {Object.keys(tabs).map((key) => (
                              <Menu.Item>
                                {({ active }) => (
                                  <Link
                                    className={classNames(activeTab === key ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}
                                    name="all"
                                    onClick={() => {
                                      setActiveTab(key);
                                    }}>
                                    {tabs[key].label} ({getUserStatsData?.[key]})
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </>
              )}
            </>
          )}

          <div className="flex flex-col mb-2">
            <PerformerList isMailing={isMailing} setSelectApplicant={setSelectApplicant} selectApplicant={selectApplicant} isSelectApplicant={isSelectApplicant} isApplicants={isApplicants} name={'userChecked'} form={formChecked} currentItems={selectorData?.data?.results} setOpenUser={setOpenUser} />
            <Pagination
              defaultCurrent={currentPage}
              total={selectorData?.data?.count}
              showSizeChanger={false}
              current={currentPage}
              disabled={selectorData?.loading}
              onChange={(e) => {
                setCurrentPage(e);
              }}
            />
          </div>
        </div>
        <div className="w-full first:w-1/4 flex flex-col mt-4 justify-between gap-6">
          <SelectionFilter isApplicants={isApplicants} disabled={!Object.keys(userChecked)?.length} form={formFilter} onSubmit={formChecked.handleSubmit(onSubmit)} />
          {isSelectApplicant && (
            <button
              type="button"
              className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov  w-full transition ease-in-out duration-300 mb-2 h-[42px] disabled:opacity-50"
              disabled={!selectApplicant}
              onClick={() => {
                onClose();
                onSendApplicant(selectApplicant);
              }}>
              Отправить анкету
            </button>
          )}
        </div>
      </div>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        open={openUser}
        width={'100%'}
        onCancel={() => {
          setOpenUser(null);
        }}
        footer={['']}>
        <ProfileIndex userId={openUser} isEditComment />
      </Modal>
      <NotificationModal
        formChecked={formChecked}
        users={Object.keys(userChecked)
          ?.filter((key) => userChecked[key])
          .map((key) => parseInt(key))}
        open={notification}
        sendDataToParent={(data) => {
          setNotification(data);
        }}
      />
    </div>
  );
}

export default SelectionPerformer;
